<template>
    <div id="content">
        <link rel="stylesheet" href="/themes/ito/css/profile.css?v=5">
        <div class="modal fade" id="ChangePasswordPopup" tabindex="-1" role="dialog"
             aria-labelledby="ChangePasswordPopup"
             aria-hidden="true" data-backdrop="static" data-keyboard=false>
            <div class="modal-dialog modal-dialog-centered ito-popup forgot-popup" role="document">
                <div class="modal-content box-shadow-main">
                    <div class="close-popup" data-dismiss="modal"></div>
                    <div class="forgot-popup-header">
                        <h3 class="popup-title">{{$t('change_password') }}</h3>
                    </div>
                    <template>
                        <div class="forgot-popup-content">
                            <p>{{$t('password_description')}}</p>
                            <div class="form-group">
                                <label class="label-input" style="display: block">{{$t('current_password') }}</label>
                                <input type="password" class="ito-input" name="current_password"
                                       :placeholder="$t('placeholder_current_password')" v-model="current_password">
                                <div class="error-message text-left" v-if="errors.current_password != ''">{{ errors.current_password }}</div>
                            </div>
                            <div class="form-group">
                                <label class="label-input" style="display: block">{{$t('new_password') }}</label>
                                <div class="d-flex">
                                    <input type="password" class="ito-input" name="new_password"
                                           :placeholder="$t('placeholder_new_password')" v-model="new_password">
                                    <div class="validate-new-pass" :class="classStrength" v-if="new_password">
                                        <div class="progres-status-pw d-flex">
                                            <div :class="strength > 0?'progres-status-pw-item active':'progres-status-pw-item'"></div>
                                            <div :class="strength > 1?'progres-status-pw-item active':'progres-status-pw-item'"></div>
                                            <div :class="strength > 2?'progres-status-pw-item active':'progres-status-pw-item'"></div>
                                        </div>
                                        <div class="progres-text-pw">
                                           {{$t('lisa_web_password_strength')}} {{textStrength}}
                                        </div>
                                    </div>
                                </div>
                                <div class="error-message text-left" v-if="errors.new_password != ''">{{ errors.new_password }}</div>
                            </div>
                            <div class="form-group">
                                <label class="label-input" style="display: block">{{$t('confirm_password') }}</label>
                                <input type="password" class="ito-input" name="confirm_password"
                                       :placeholder="$t('placeholder_confirm_password')" v-model="confirm_password">
                                <div class="error-message text-left" v-if="errors.confirm_password != ''">{{ errors.confirm_password }}</div>
                            </div>

                        </div>

                        <div class="forgot-popup-footer">
                            <div class="form-group d-flex justify-content-center">
                                <div :class="(confirm_password != '' && confirm_password != '' && confirm_password != '') ? 'ito-btn-small active' : 'ito-btn-small'"
                                     @click="(confirm_password != '' && confirm_password != '' && confirm_password != '')? changeNewPass() : ''">{{ $t('save') }}
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div id="changePassSuccess" class="modal fade" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered ito-popup" role="document" data-backdrop="static" data-keyboard=false>
                <div class="modal-content">

                    <div class="close-popup" data-dismiss="modal"></div>
                    <div class="modal-success">
                        <h4 class="title">{{$t('password_updated')}}</h4>

                        <img src="/themes/ito/images/get-rewarded.svg" alt="">

                        <h6>{{$t('password_has_been_updated_successfully')}}</h6>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div id="page-header-fixed" class="mb-25">
                <div class="container">
                    <div id="page-header">
                        <div class="buttons">
                            <div class="btn-group">
                                <router-link :to="{ name: 'parent_report' }" @click.native="getSoundClick">
                                    <button type="button" class="btn btn-default">{{$t('report')}}</button>
                                </router-link>
                                <router-link :to="{ name: 'parent_feedback' }" @click.native="getSoundClick">
                                    <button type="button" class="btn btn-default">{{$t('feedback')}}</button>
                                </router-link>
                                <router-link :to="{ name: 'parent_account' }" @click.native="getSoundClick">
                                    <button type="button" class="btn btn-default active">{{$t('account_information')}}</button>
                                </router-link>
                                <router-link :to="{ name: 'parent_upgrade_account' }" @click.native="getSoundClick">
                                    <button type="button" class="btn btn-default">{{$t('upgrade_account')}}</button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card card-profile card-account">
                <div class="card-body">
                    <h5 class="card-title">
                        <span class="title">{{$t('account_information')}}</span>
                        <a href="#" @click="onLogout">
                            <span class="logout">{{ $t('log_out') }}</span>
                        </a>
                    </h5>

                    <div class="card-content">
                        <div class="profile-show">
                            <div class="profile-avatar-upload">
                                <div class="profile-avatar-upload-c" :style="{ backgroundImage: `url(${user_info.avatar_url})` }"></div>

                                <a href="#" class="upload-btn" data-toggle="modal" data-target="#uploadAvatarModal">
                                    <img src="/themes/ito/images/icon-camera-upload.svg" alt=""/>
                                </a>

                                <div class="emoticon" v-if="user_info.emoji_url">
                                    <img :src="user_info.emoji_url"/>
                                </div>
                            </div>

                            <div class="profile-avatar-info">
                                <p>{{ $t('user_id') }}: <span class="value">{{ user_info.user_id }}</span></p>
                                <p><AppIcon :src="$store.state.configs.default_gem_icon" :size="15" /> {{ $t('total') }}: <span
                                        class="value">{{ user_info.gem | toCommas }}</span></p>
                                <p><AppIcon :src="$store.state.configs.default_gem_icon" :size="15" /> {{ $t('this_month') }}:
                                    <span class="value">{{ user_info.gem_month | toCommas }}</span></p>
                            </div>

                            <div class="profile-avatar-button">
                                <button class="btn btn-default btn-change-password" @click="changePassword()">{{
                                    $t('change_password') }}
                                </button>
                                <router-link :to="{ name: 'parent_upgrade_account' }" @click.native="getSoundClick">
                                    <button class="btn btn-default btn-update btn-upgrate">{{$t('upgrade_account')}}</button>
                                </router-link>
                            </div>
                        </div>
                        <div class="profile-update">
                            <form>
                                <div class="row">
                                    <label class="col-sm-6 col-form-label">{{ $t('username') }}</label>
                                    <div class="col-sm-6">
                                        <input type="text" name="username" class="form-control" v-model="user.username"
                                               :placeholder="$t('username')" disabled/>
                                    </div>
                                </div>                                
                                <div class="row">
                                    <label class="col-sm-6 col-form-label">{{ $t('full_name') }}</label>
                                    <div class="col-sm-6">
                                        <input type="text" name="full_name" class="form-control" v-model="user.fullname"
                                               :placeholder="$t('full_name')"/>
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-sm-6 col-form-label">{{ $t('birthday') }}</label>
                                    <div class="col-sm-6">
                                        <input type="text" name="birthday" class="form-control date datepicker birthday"
                                               v-model="user.birthday"
                                               autocomplete="off" :placeholder="$t('birthday')"/>
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-sm-6 col-form-label">{{ $t('relationship') }}</label>
                                    <div class="col-sm-6">
                                        <select class="form-control" v-model="user.relationship" style="width: 150px">
                                            <option value="">{{ $t('choose_relationship') }}</option>
                                            <option value="father" selected>{{ $t('father') }}</option>
                                            <option value="mother">{{ $t('mother') }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-sm-6 col-form-label">{{ $t('grade') }}</label>
                                    <div class="col-sm-6">
                                        <!--<select class="form-control" v-model="user.grade" style="width: 150px">-->
                                            <!--<option value="0">{{ $t('select_grade') }}</option>-->
                                            <!--<option value="1" selected>1</option>-->
                                            <!--<option value="2">2</option>-->
                                        <!--</select>-->
                                        <input type="text" name="grade" class="form-control"
                                               :value="user.grade" disabled
                                               autocomplete="off">
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-sm-6 col-form-label">{{$t('account_type')}}</label>
                                    <div class="col-sm-6">
                                        <span class="desc-blue">{{parent_info.account_type}}</span>
                                    </div>
                                </div>   
                                <div class="row">
                                    <label class="col-sm-6 col-form-label">{{$t('exp_date')}}</label>
                                    <div class="col-sm-6">
                                        <span class="desc-blue">{{timeConverter(parent_info.expired_date)}}</span>
                                    </div>
                                </div>                                
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card card-account card-account-form">
                <div class="card-body">
                    <h5 class="card-title">
                        <span class="title">{{$t('contact_details')}}</span>
                    </h5>

                    <div class="card-content">                      
                        <div class="row" style="width: 100%;">
                            <div class="col-md-6">
                                <label class="col-form-label">{{ $t('phone') }}</label>
                                <div>
                                    <input type="text" name="phone" class="form-control" :value="contact_user.phone"
                                        :placeholder="$t('phone')" autocomplete="off" :disabled="parent_info.student_type==1"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label class="col-form-label">{{ $t('email') }}</label>
                                <div>
                                    <input type="text" name="email" class="form-control" :value="parent_info.email"
                                        :placeholder="$t('email')" autocomplete="off" :disabled="parent_info.student_type==1"/>
                                </div>
                            </div>                                
                        </div> 
                        <div class="row" style="width: 100%;">
                            <div class="col-md-6">
                                <label class="col-form-label">{{ $t('address') }}</label>
                                <div>
                                    <input type="text" name="address" class="form-control" :value="contact_user.address"
                                        :placeholder="$t('address')" autocomplete="off" :disabled="parent_info.student_type==1"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label class="col-form-label">{{ $t('ward') }}</label>
                                <div>
                                    <input type="text" name="ward" class="form-control" :value="contact_user.ward"
                                        :placeholder="$t('ward')" autocomplete="off" :disabled="parent_info.student_type==1"/>
                                </div>
                            </div>                                
                        </div>    
                        <div class="row" style="width: 100%;">
                            <div class="col-md-6">
                                <label class="col-form-label">{{ $t('province') }}</label>
                                <div>
                                    <input type="text" name="province" class="form-control" :value="contact_user.province"
                                        :placeholder="$t('province')" autocomplete="off" :disabled="parent_info.student_type==1"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label class="col-form-label">{{ $t('country') }}</label>
                                <div>
                                    <input type="text" name="country" class="form-control" :value="contact_user.country"
                                        :placeholder="$t('country')" autocomplete="off" :disabled="parent_info.student_type==1"/>
                                </div>
                            </div>                                
                        </div>                                                                            
                    </div>
                </div>
            </div>    

            <div class="card card-account card-account-form" v-if="parent_info.student_type == 1">
                <div class="card-body">
                    <h5 class="card-title">
                        <span class="title">School Information</span>
                    </h5>

                    <div class="card-content">                      
                        <div class="row" style="width: 100%;">
                            <div class="col-md-6">
                                <label class="col-form-label">{{ $t('school') }}</label>
                                <div>
                                    <input type="text" name="school" class="form-control" :value="contact_school.school"
                                        :placeholder="$t('school')" autocomplete="off" :disabled="parent_info.student_type==1"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label class="col-form-label">{{ $t('class') }}</label>
                                <div>
                                    <input type="text" name="class" class="form-control" :value="contact_school.class"
                                        :placeholder="$t('class')" autocomplete="off" :disabled="parent_info.student_type==1"/>
                                </div>
                            </div>                                
                        </div> 
                        <div class="row" style="width: 100%;">
                            <div class="col-md-6">
                                <label class="col-form-label">{{ $t('address') }}</label>
                                <div>
                                    <input type="text" name="address" class="form-control" :value="contact_school.address"
                                        :placeholder="$t('address')" autocomplete="off" :disabled="parent_info.student_type==1"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label class="col-form-label">{{ $t('ward') }}</label>
                                <div>
                                    <input type="text" name="ward" class="form-control" :value="contact_school.ward"
                                        :placeholder="$t('ward')" autocomplete="off" :disabled="parent_info.student_type==1"/>
                                </div>
                            </div>                                
                        </div>    
                        <div class="row" style="width: 100%;">
                            <div class="col-md-6">
                                <label class="col-form-label">{{ $t('province') }}</label>
                                <div>
                                    <input type="text" name="province" class="form-control" :value="contact_school.province"
                                        :placeholder="$t('province')" autocomplete="off" :disabled="parent_info.student_type==1"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label class="col-form-label">{{ $t('country') }}</label>
                                <div>
                                    <input type="text" name="country" class="form-control" :value="contact_school.country"
                                        :placeholder="$t('country')" autocomplete="off" :disabled="parent_info.student_type==1"/>
                                </div>
                            </div>                                
                        </div>                                                                            
                    </div>
                </div>
            </div>                         
        </div>

        <div class="modal fade" id="uploadAvatarModal" tabindex="-1" aria-labelledby="uploadAvatarModal"
             aria-hidden="true"
             data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="upload-avatar">
                            <div class="upload-avatar-info">
                                <h3 class="title">{{ $t('student_profile') }}</h3>

                                <div class="avatar">
                                    <img ref="avatar_url" :src="user_info.avatar_url" alt="" class="avatar-img"/>

                                    <img ref="emoticon_url" class="emoticon" v-if="user_info.emoji_url"
                                         :src="user_info.emoji_url" alt="">
                                </div>

                                <button class="btn btn-default btn-update" @click="updateAvatar">
                                    {{ $t('save') }}
                                </button>
                            </div>
                            <div class="upload-avatar-select">
                                <div class="upload-avatar-tabs">
                                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link active" id="home-tab" data-toggle="tab"
                                                    data-target="#home" type="button" role="tab" aria-controls="home"
                                                    aria-selected="true">{{$t("avatar")}}
                                            </button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link" id="profile-tab" data-toggle="tab"
                                                    data-target="#profile" type="button" role="tab"
                                                    aria-controls="profile"
                                                    aria-selected="false">{{$t("sticker")}}
                                            </button>
                                        </li>
                                    </ul>

                                    <div class="tab-content">
                                        <div class="tab-pane active" id="home" role="tabpanel"
                                             aria-labelledby="home-tab">
                                            <div class="avatar-list nano">
                                                <div class="nano-content">
                                                    <div class="row">
                                                        <div class="col-md-3 avatar-item" style="margin-top: 18px;">
                                                            <div class="thumb">
                                                                <div class="thumb-content">
                                                                    <label class="avatar-item-upload"
                                                                           for="uploadAvatar">
                                                                        <img src="/themes/ito/images/avatar-0.svg?v=2"
                                                                             alt="">
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <input type="file" id="uploadAvatar" name="avatar"
                                                                   accept="image/*" style="display: none"
                                                                   @change="addEvent"/>
                                                        </div>
                                                        <div class="col-md-3 avatar-item"
                                                             v-for="(avatar, index) in avatars" :key="index"
                                                             @click="selectAvatar(avatar)">
                                                            <div class="thumb">
                                                                <div class="thumb-content">
                                                                    <img :src="avatar.url" alt="">

                                                                    <div class="avatar-item-checked"
                                                                         v-if="avatar.id  == user.avatar_id">
                                                                        <i class="ito-icon-checked"></i>
                                                                    </div>
                                                                    <div class="avatar-item-gem"
                                                                         v-else-if="avatar.price > 0">
                                                                        <span class="ito-gem">{{ avatar.price }}</span>
                                                                        <AppIcon :src="$store.state.configs.default_gem_icon" :size="15" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane" id="profile" role="tabpanel"
                                             aria-labelledby="profile-tab">
                                            <div class="avatar-list nano">
                                                <div class="nano-content">
                                                    <div class="row">
                                                        <div class="col-md-3 avatar-item"
                                                             v-for="(emoticon, index) in emoticons" :key="index"
                                                             @click="selectEmoticon(emoticon)">
                                                            <div class="thumb">
                                                                <div class="thumb-content">
                                                                    <img :src="emoticon.url" alt="">

                                                                    <div class="avatar-item-checked"
                                                                         v-if="emoticon.id  == user.emoji_id">
                                                                        <i class="ito-icon-checked"></i>
                                                                    </div>
                                                                    <div class="avatar-item-gem"
                                                                         v-else-if="emoticon.price > 0">
                                                                        <span class="ito-gem">{{ emoticon.price }}</span>
                                                                        <AppIcon :src="$store.state.configs.default_gem_icon" :size="15" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <img class="modal-close" src="/themes/ito/images/icon-close-1.svg" alt=""
                                     data-dismiss="modal"
                                     aria-label="Close"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getAvatars, updateAvatar, updateProfile} from '../../models/profile'
    import {changeNewPassword} from '../../models/auth'
    import {getParentInfo} from '../../models/parent'
    import axios from "axios";
    import AppIcon from "@/components/common/AppIcon.vue";
    import { soundClick } from '../../utils/utils'

    export default {
        name: "ParentAcount",
        title: 'Parent - Acount',
        components: {
            AppIcon
        },

        data() {
            return {
                errors: {
                    address: '',
                    fullname: '',
                    current_password: '',
                    new_password: '',
                    confirm_password: '',
                },
                user: {
                    fullname: '',
                    birthday: '',
                    relationship: '',
                    grade: 0,
                    type: 2,
                    avatar_id: -1,
                    avatar_img: '',
                    emoji_id: 0,
                    extension_file: 'png',
                    username: ''
                },
                avatar: '',
                avatars: [],
                emoticons: [],
                current_password: '',
                new_password: '',
                confirm_password: '',
                strength: 0,
                classStrength: '',
                textStrength: '',
                parent_info: [],
                contact_user: {
                    phone: '',
                    address: '',
                    ward: '',
                    province: '',
                    country: '',
                },
                contact_school: {
                    school: '',
                    class: '',
                    address: '',
                    ward: '',
                    province: '',
                    country: '',
                }
            };
        },

        computed: {
            user_info() {
                const user = this.$store.state.user_info;

                this.user.fullname = user.fullname;
                this.user.birthday = user.birthday;
                this.user.relationship = user.relationship;
                this.user.grade = user.grade;
                this.user.avatar_id = user.avatar_id;
                this.user.emoji_id = user.emoji_id;
                this.user.avatar_img = user.avatar_url;
                this.user.username = user.username;

                return this.$store.state.user_info
            }
        },

        created() {
            this.$store.commit('setMenuActive', 'parent');

            this.fetch();
        },
        watch: {
            'new_password': function (newVal, oldVal) {
                this.strengPassword(newVal);
                this.errors.new_password = (newVal != this.user.username) ? 'New password cannot be  the same as the username.' : '';
            },
            'strength': function (newVal, oldVal) {
                if(newVal == 1){
                    this.classStrength = 'pw-weak';
                    this.textStrength = 'Weak';
                }else if(newVal == 2){
                    this.classStrength = 'pw-normal';
                    this.textStrength = 'Good';
                }else if(newVal == 3){
                    this.classStrength = 'pw-strong';
                    this.textStrength = 'Strong';
                }else{
                    this.classStrength = '';
                    this.textStrength = '';
                }
            },
            'confirm_password': function (newVal, oldVal) {
                this.errors.confirm_password = (newVal != this.new_password) ? 'Confirm password does not match.' : '';
            }
        },
        methods: {
            async fetch() {
                const that = this;

                await axios.all([
                    getAvatars(),
                    getParentInfo(),
                ]).then(axios.spread((response,info) => {
                    if (response.data.code != 0) {
                        return;
                    }

                    const items = response.data.results.items || [];

                    items.forEach(function (item) {
                        if (item.type == 0) {
                            that.avatars.push(item)
                        }
                        if (item.type == 1) {
                            that.emoticons.push(item)
                        }
                    });
                    if (info.data.code != 0){
                        return
                    }
                    this.parent_info = info.data.results
                    this.contact_user.phone = this.parent_info.contact_user.phone;
                    this.contact_user.address = this.parent_info.contact_user.address;
                    this.contact_user.ward = this.parent_info.contact_user.ward;
                    this.contact_user.province = this.parent_info.contact_user.city;
                    this.contact_user.country = this.parent_info.contact_user.country;
                    this.contact_school.school = this.parent_info.contact_school.school;
                    this.contact_school.class = this.parent_info.contact_school.class;
                    this.contact_school.address = this.parent_info.contact_school.address;
                    this.contact_school.ward = this.parent_info.contact_school.ward;
                    this.contact_school.province = this.parent_info.contact_school.city;
                    this.contact_school.country = this.parent_info.contact_school.country;
                }));

                this.$nextTick(function () {
                    //initDatepicker();

                    $('.birthday').datepicker({
                        dateFormat: 'dd/mm/yy',
                        changeMonth: true,
                        changeYear: true,
                        showOtherMonths: true,
                        selectOtherMonths: false,
                        yearRange: '1900:+0',
                        monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
                    }).on('change', (e) => {
                        this.searchEvent(e);
                    });

                    initNanoScroller();
                    $('button[data-toggle="tab"]').on('show.bs.tab', function (e) {
                        initNanoScroller();
                    });
                    $('button[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                        initNanoScroller();
                    });
                    $('#uploadAvatarModal').on('shown.bs.modal', function () {
                        initNanoScroller();
                    });
                })
            },

            getSoundClick(){
                soundClick();
            },   

            searchEvent({target}) {
                this.user[target.name] = target.value;
            },

            addEvent({target}) {
                const that = this;

                switch (target.name) {
                    case 'avatar':
                        const reader = new FileReader();

                        const images = target.files;

                        if (images.length == 0) {
                            break;
                        }

                        const image = images[0];

                        that.avatar = image;

                        //console.log(image.name)

                        reader.onload = function (e) {
                            that.user.avatar_id = -1;
                            that.user.avatar_img = e.target.result;
                            that.user.extension_file = image.name.split('.').pop();

                            that.$refs.avatar_url.setAttribute("src", e.target.result)
                        };

                        if (/\.(jpe?g|png|gif)$/i.test(image.name)) {
                            reader.readAsDataURL(image);
                        }

                        break;
                }
            },

            selectAvatar(avatar) {
                this.user.avatar_id = avatar.id;
                this.user.avatar_img = avatar.url;

                this.$refs.avatar_url.setAttribute("src", avatar.url)
            },

            selectEmoticon(emoticon) {
                this.user.emoji_id = emoticon.id;
                this.user.emoji_url = emoticon.url;

                this.$refs.emoticon_url.setAttribute("src", emoticon.url)
            },

            updateAvatar() {
                const that = this;
                const formData = new FormData();

                formData.append('avatar_id', this.user.avatar_id);
                formData.append('avatar_img', this.user.avatar_img);
                formData.append('emoji_id', this.user.emoji_id);
                formData.append('emoji_id', this.user.emoji_id);
                formData.append('type', this.user.type);
                formData.append('extension_file', this.user.extension_file);

                that.$store.commit("setLoading", true);

                updateAvatar({
                    avatar_id: this.user.avatar_id,
                    avatar_img: this.user.avatar_img,
                    emoji_id: this.user.emoji_id,
                    type: this.user.type,
                    extension_file: this.user.extension_file,
                    //is_raw: true
                }).then((response) => {
                    that.$store.commit("setLoading", false);

                    if (response.data.code != 0) {
                        alert(response.data.msg)

                        return;
                    }

                    that.user_info.avatar_id = response.data.results.avatar_id;
                    that.user_info.avatar_url = response.data.results.avatar_url;
                    that.user_info.emoji_id = response.data.results.emoji_id;
                    that.user_info.emoji_url = response.data.results.emoji_url;

                    $('#uploadAvatarModal').modal('hide');
                }).catch((response) => {
                    that.$store.commit("setLoading", false);

                    console.error(response)
                });
            },

            onSubmit(e) {
                const that = this;
                const formData = new FormData();

                formData.append('fullname', this.user.fullname);
                formData.append('birthday', moment(this.user.birthday, 'DD/MM/YYYY').format('YYYY-MM-DD'));
                formData.append('relationship', this.user.relationship);
                //formData.append('grade', this.user.grade);

                that.$store.commit("setLoading", true);

                updateProfile(formData).then((response) => {
                    that.$store.commit("setLoading", false);

                    if (response.data.code != 0) {
                        alert(response.data.msg)

                        return;
                    }

                    //alert('Ok')
                }).catch((response) => {
                    that.$store.commit("setLoading", false);

                    console.error(response)
                });

                e.preventDefault();
            },

            onLogout(e) {
                this.$store.dispatch('logout').then(() => {
                    window.location.href = "/login";
                });

                e.preventDefault();
            },
            changePassword() {
                $('#ChangePasswordPopup').modal('show');
            },
            changeNewPass(){
                const that = this;
                const formData = new FormData();

                if(that.new_password.length < 8){
                    that.errors.new_password = 'The new password must be at least 8 characters.';
                    return false;
                }
                formData.append('old_pass', that.current_password)
                formData.append('new_pass', that.new_password);
                formData.append('confirm_pass', that.confirm_password);

                that.$store.commit("setLoading", true);

                changeNewPassword(formData).then((response) => {
                    that.$store.commit("setLoading", false);

                    if (response.data.code != 0) {
                        alert(response.data.msg)

                        return;
                    }
                    // alert('Ok');
                    $('#ChangePasswordPopup').modal('hide');
                    $('#changePassSuccess').modal('show');
                    that.resetPasswordState();
                }).catch((response) => {
                    that.$store.commit("setLoading", false);
                    console.error(response)
                });
            },
            resetPasswordState(){
                this.current_password = '';
                this.new_password = '';
                this.confirm_password = '';
            },
            strengPassword(password){
                let str1 = 0;
                let str2 = 0;
                let str3 = 0;
                (password.length >= 8)? str1 = 1 : str1 = 0;
                (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/))? str2 = 1 : str2 = 0;
                // if (password.match(/([a-zA-Z])/) && password.match(/([0-9])/)){this.strength += 1}
                (password.match(/([!,%,&,@,#,$,^,*,?,_,~])/))? str3 = 1 : str3 = 0;
                this.strength = str1 + str2 + str3;
            },
            timeConverter(UNIX_timestamp){
                var a = new Date(UNIX_timestamp * 1000);
                var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
                var year = a.getFullYear();
                var month = months[a.getMonth()];
                var date = a.getDate();
                var hour = a.getHours();
                var min = a.getMinutes();
                var sec = a.getSeconds();
                var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec ;
                return time;
            },
        }
    }
</script>

<style scoped>
    .card-account{
        margin-bottom: 15px;
    }
    .card-account-form .form-control {
        margin-bottom: 5px;
    }
    .card-account-form .card-content{
        padding: 40px 115px;
    }
    .avatar img.avatar-img{
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
    }
</style>
